var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',[_vm._v(_vm._s(_vm.label)),_vm._t("default"),_c('input',_vm._g({attrs:{"type":"checkbox","id":'abi-'+_vm.name,"disabled":_vm.disabled},domProps:{"checked":_vm.checked,"value":_vm.value}},_vm.$listeners)),_c('span',{staticClass:"checkmark"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }